<template>
    <div class="content-list-foot">
        <span class="mr10" v-if="data.releaseStartTime">{{formatTimestamp(data.releaseStartTime,'yyyy-MM-dd')}}</span>
        <span class="Ce6e6e6 mr10" v-if="data.releaseDeptName && data.releaseStartTime">|</span>
        <span class="oneRowEllipsis releaseDeptName">{{data.releaseDeptName}}</span>
        <span class="autoFlex"></span>
        <sw-icon icon="eye" class="mr7"></sw-icon>
        <span>{{data.readCount || 0}}</span>
    </div>
</template>

<script>
    import {formatTimestamp} from '@/utils/utils';
    export default {
        name: "ListFoot",
        props: {
            data: { type: Object, default: () => []}
        },
        methods: {
            formatTimestamp(data,formmat) {
                return formatTimestamp(data, formmat);
            }
        }
    }
</script>

<style scoped lang="scss" >
  .content-list-foot {
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #999999;
      font-size: 12px;
    .releaseDeptName {
      width: calc( 100% - 190px);
    }
  }

</style>